"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Apple = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Apple = props => /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/_react.default.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/_react.default.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
}), /*#__PURE__*/_react.default.createElement("g", {
  fill: "#000",
  fillRule: "nonzero"
}, /*#__PURE__*/_react.default.createElement("path", {
  d: "M15.316 3.814c.814-1.018 1.367-2.385 1.221-3.782-1.191.06-2.645.786-3.487 1.805-.756.872-1.425 2.297-1.25 3.635 1.337.116 2.673-.669 3.516-1.658M16.522 5.733C14.579 5.618 12.928 6.836 12 6.836c-.928 0-2.348-1.044-3.885-1.016-2 .029-3.855 1.16-4.87 2.958-2.087 3.597-.55 8.933 1.48 11.863.985 1.45 2.173 3.046 3.738 2.988 1.479-.058 2.059-.957 3.856-.957 1.796 0 2.319.957 3.884.928 1.623-.029 2.638-1.45 3.624-2.9 1.13-1.653 1.594-3.249 1.623-3.336-.03-.03-3.13-1.219-3.16-4.786-.029-2.987 2.435-4.408 2.551-4.496-1.391-2.058-3.565-2.29-4.32-2.349"
}))));
exports.Apple = Apple;
Apple.displayName = "Apple";